export default "__VITE_ASSET__BlxJWFVd__"